import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactApexChart from 'react-apexcharts';
import { Card, CardHeader, Box } from '@material-ui/core';
import { BaseOptionChart } from './BaseOptionChart';
import { merge } from '../generics/utils';
const CHART_DATA = [
    {
        name: 'Team A',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
    },
    {
        name: 'Team B',
        type: 'column',
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
    },
    {
        name: 'Team C',
        type: 'column',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
    },
];
export function AnalyticsPaymentsStatus() {
    const chartOptions = merge(BaseOptionChart(), {
        stroke: { width: [0, 2, 3] },
        plotOptions: { bar: { columnWidth: '11%', borderRadius: 4 } },
        fill: { type: ['solid', 'gradient', 'solid'] },
        labels: [
            '01/01/2021',
            '02/01/2021',
            '03/01/2021',
            '04/01/2021',
            '05/01/2021',
            '06/01/2021',
            '07/01/2021',
            '08/01/2021',
            '09/01/2021',
            '10/01/2021',
            '11/01/2021',
        ],
        xaxis: { type: 'datetime' },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (y) => {
                    if (typeof y !== 'undefined') {
                        return `${y.toFixed(0)} visits`;
                    }
                    return y;
                },
            },
        },
    });
    return (_jsxs(Card, { children: [_jsx(CardHeader, { title: "Website Visits", subheader: "(+43%) than last year" }, void 0), _jsx(Box, Object.assign({ sx: { p: 3, pb: 1 }, dir: "ltr" }, { children: _jsx(ReactApexChart, { type: "line", series: CHART_DATA, options: chartOptions, height: 364 }, void 0) }), void 0)] }, void 0));
}
//# sourceMappingURL=AnalyticsPaymentsStatus.js.map